/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentSecret = {
    properties: {
        adminCode: {
            type: 'string',
            isRequired: true,
        },
        managerCode: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
